<script>
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
import moment from "moment";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import DatePicker from "vue2-datepicker";

/**
 * Add-product component
 */
export default {
  page: {
    title: "Nueva poliza auto",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Multiselect, Layout, DatePicker, PageHeader },
  methods: {
    GuardarDatosPersonales() {
      firebase
        .firestore()
        .collection("Usuarios")
        .doc(this.rfc)
        .set({
          nombre: this.nombre,
          fechaNacimiento: moment(this.fechaNacimiento, "x").format(
            "DD-MM-YYYY"
          ),
          rfc: this.rfc.toUpperCase(),
          telefono: this.telefono,
          email: this.email.toLowerCase(),
          empresa: this.empresa,
        })
        .then(() => {
          this.$router.push({
            name: "Agregar Poliza",
            params: { rfc: this.rfc },
          });
        })
        .catch((error) => {
          alert(error);
        });
    },
  },
  mounted() {
    firebase
      .firestore()
      .collection("ImgEmpresa")
      .get()
      .then((querySnapshot) => {
        var array = [];
        querySnapshot.forEach((documentSnapshot) => {
          array.push({
            nombreEmpresa: documentSnapshot.data().nombreEmpresa,
            numTelefono: documentSnapshot.data().numTelefono,
          });
        });

        this.dataEmpresaList = array;
        this.dataEmpresa = array;
      });
  },
  data() {
    return {
      title: "Registro de nuevo usuario",
      options: [],
      items: [
        {
          text: "Registro",
          href: "/",
        },
        {
          text: "Usuario",
          active: true,
        },
      ],

      nombre: null,
      dataEmpresaList: [],
      fechaNacimiento: null,
      rfc: null,
      telefono: null,
      email: null,
      empresaOptions: [
        "DIESEL",
        "INTERMEX",
        "SAFRAN",
        "IBS CONSULTORES",
        "INTERMETRO",
      ],
      empresa: null,
      nombreEmpresa: null,
      dataEmpresa: [],
    };
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label>Nombre completo</label>
                  <input v-model="nombre" type="text" class="form-control" />
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-12">
                      <label class="control-label">RFC</label>
                      <input
                        type="text"
                        v-model="rfc"
                        class="form-control"
                        maxlength="10"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-12">
                      <label class="control-label">Fecha nacimiento</label>
                      <date-picker
                        v-model="fechaNacimiento"
                        :first-day-of-week="1"
                        lang="en"
                        confirm
                      ></date-picker>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-6">
                      <label class="control-label">Telefono</label>
                      <input
                        type="number"
                        v-model="telefono"
                        maxlength="10"
                        class="form-control"
                        oninput="if(this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                      />
                    </div>
                    <div class="col-sm-6">
                      <label class="control-label">Correo electronico</label>
                      <input type="text" v-model="email" class="form-control" />
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-6">
                      <label class="control-label">Empresa</label>
                      <multiselect
                        v-model="empresa"
                        label="nombreEmpresa"
                        track-by="nombreEmpresa"
                        :show-labels="false"
                        :options="dataEmpresa"
                      ></multiselect>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="text-sm-right">
                <button class="btn btn-success" @click="GuardarDatosPersonales">
                  <i class="mdi mdi-account-plus mr-1"></i> Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- end row -->
  </Layout>
</template>
